import * as t from './actionTypes';

export function edit(record) {
    return {
        type: t.EDIT,
        payload: record
    };
}